import type { QueryClient } from "@tanstack/react-query";
import type { Conversation } from "../api/conversations";

/** The street chat's groups, newest first (the server's order). */
export const stcGroupConvsKey = (stcId: number | null) => ["stcGroupConvs", stcId] as const;

/**
 * Every cached copy of the conversation with this id among those the app already loaded: street chat's group
 * lists, the conversation list and single fetches, in that order (one GC can sit in several), so a caller takes the
 * first copy carrying the field it needs. No fetch.
 */
export function cachedConversations(qc: QueryClient, convId: number | string): Conversation[] {
  return [
    ...qc.getQueriesData<Conversation[]>({ queryKey: ["stcGroupConvs"] }),
    ...qc.getQueriesData<Conversation[]>({ queryKey: ["conversations"] }),
    ...qc.getQueriesData<Conversation>({ queryKey: ["conv"] }),
  ]
    .flatMap(([, data]) => (Array.isArray(data) ? data : data ? [data] : []))
    .filter((c) => String(c?.id) === String(convId));
}
